module.exports = __webpack_public_path__ + "a6c53193fcc23972ce20697ef1813825.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-scarf-yellow-s.png
// module id = 2848
// module chunks = 0